import http from './http';
import axios from 'axios';

export const uploadAPI = {
  // 업로드 초기화
  initUpload: async (data) => {
    const response = await http.post('/api/posts/upload/init', data);
    return response.data;
  },

  // MinIO에 직접 업로드
  uploadToMinIO: async (url, file, onProgress) => {
    await axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });
  },

  // 업로드 완료
  completeUpload: async (data) => {
    const response = await http.post('/api/posts/upload/complete', data);
    return response.data;
  },

  // 직접 업로드 (간편한 방식)
  directUpload: async (file, caption, hashtags, aspectRatio, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('caption', caption);
    
    // 해시태그 추가
    if (hashtags && hashtags.length > 0) {
      hashtags.forEach(tag => {
        formData.append('hashtags', tag);
      });
    }
    
    formData.append('aspectRatio', aspectRatio || '1:1');

    const response = await http.post('/api/posts/upload/direct', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });
    return response.data;
  },

  // 다중 파일 업로드 (인스타 스타일)
  multiUpload: async (files, caption, hashtags, aspectRatio, onProgress) => {
    const formData = new FormData();
    
    // 여러 파일 추가
    files.forEach((file, index) => {
      formData.append('files', file);
    });
    
    formData.append('caption', caption);
    
    // 해시태그 추가
    if (hashtags && hashtags.length > 0) {
      hashtags.forEach(tag => {
        formData.append('hashtags', tag);
      });
    }
    
    formData.append('aspectRatio', aspectRatio || '1:1');

    const response = await http.post('/api/posts/upload/multi', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });
    return response.data;
  },
};

